/**
 * ProductGridNew2.js — Product card layout variant 2 (with wishlist support).
 *
 * Like ProductGridNew but also accepts AddtoWishlist and getAllWishlist props
 * for heart-icon wishlist toggling.
 *
 * Props:
 *  - product {object}                     Shopify product node.
 *  - AddtoCart {Function}                 Adds a variant to the Shopify cart.
 *  - AddtoWishlist {Function}             Toggles a product in the wishlist.
 *  - getAllWishlist {Array}                Current wishlist product slugs.
 *  - Program_structure_images {Array}     Slug-to-image mapping.
 *  - is_ten_minite_less {Function}        Returns true if event starts in <10 min.
 *  - program_date_is_gone_or_not {Function} Returns true if event date has passed.
 *  - GAurl {string}                       Google Ads query string appended to links.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sanitizeText } from '../../../utils/text';

// ─── Images ───────────────────────────────────────────────────────────────────
import pm from '../../../images/pm-new.svg';
import ps from '../../../images/ps-new.svg';
import sl from '../../../images/sl-new.svg';
import ep from '../../../images/ep-new.svg';
import user from '../../../images/user-ic.png';
import laptop from '../../../images/laptop-ic.png';
import calendar from '../../../images/calendar-ic.png';
import watch from '../../../images/watch-ic.png';
import { LikeIcon } from '../../../icons';
const ProductGridNew2 = ({ product, AddtoCart, Program_structure_images, is_ten_minite_less, program_date_is_gone_or_not, AddtoWishlist, getAllWishlist, GAurl, bookmarkAddedLabel }) => {

    const [metaData, set_metaData] = useState({});

    useEffect(() => {
        (product?.metafields || []).forEach((meta_val, meta_key) => {
            if (meta_val.key == 'all_data') {
                set_metaData(JSON.parse(meta_val.value));
            }
        })
    }, []);






    const [substantive_law, setSubstantive_law] = useState(metaData.Substantive_Law__c != undefined ? metaData.Substantive_Law__c : 0);
    const [professional_skills, setProfessional_skills] = useState(metaData.Professional_Skills__c != undefined ? metaData.Professional_Skills__c : 0);
    const [practise_managment_skill, setPractise_managment_skill] = useState(metaData.Practice_Management_Business_Skills__c != undefined ? metaData.Practice_Management_Business_Skills__c : 0);
    const [ethics_professional_responsibi, setEthics_professional_responsibi] = useState(metaData.Ethics_Professional_Responsibility__c != undefined ? metaData.Ethics_Professional_Responsibility__c : 0);
    const [totalCpdPoints, setTotalCpdPoints] = useState(substantive_law + professional_skills + practise_managment_skill + ethics_professional_responsibi);
    const [venue, setVenue] = useState('');
    const [DeliveryMode, setDeliveryMode] = useState([]);
    const [longPromotionMessage, setLongPromotionMessage] = useState('');
    const [shortPromotionMessage, setShortPromotionMessage] = useState('');
    const [program_date_time_line_2, setProgram_date_time_line_2] = useState('');
    const [program_date_time_line_1, setProgram_date_time_line_1] = useState('');
    const [reached_capacity, set_reached_capacity] = useState(false);

    const [DefaultRadioValue, setDefaultRadioValue] = useState("");

    const [DefaultRadio, setDefaultRadio] = useState(0);
    const [Program_Structure__c, setProgram_Structure__c] = useState(undefined);
    const [Early_Bird_Price__c, setEarly_Bird_Price__c] = useState(undefined);
    const [show_early_bird, set_show_early_bird] = useState(false);
    const [Price_Message__c, set_Price_Message__c] = useState('');

    const [sDate, setsDate] = useState(null);

    const [presentor, setpresentor] = useState([])

    const [RecordType, setRecordType] = useState("")

    const UpdateRadio = (value, index) => {

        setDefaultRadioValue(value);
        setDefaultRadio(index);
    }


    const [TEN_MIntLeft, setTEN_MIntLeft] = useState(false);
    const [isProgramOver, setisProgramOver] = useState(false);


    const [Program_structure_image, setProgram_structure_image] = useState(['https://engine.leocussen.edu.au/sync/img/logo_updated.png']);


    const isNotEmpty = (value) => {
        return value !== null && value !== undefined;
    }

    useEffect(() => {
        setSubstantive_law(metaData.Substantive_Law__c !== undefined ? metaData.Substantive_Law__c : 0);
        setProfessional_skills(metaData.Professional_Skills__c !== undefined ? metaData.Professional_Skills__c : 0);
        setPractise_managment_skill(metaData.Practice_Management_Business_Skills__c !== undefined ? metaData.Practice_Management_Business_Skills__c : 0);
        setEthics_professional_responsibi(metaData.Ethics_Professional_Responsibility__c !== undefined ? metaData.Ethics_Professional_Responsibility__c : 0);
        setTotalCpdPoints(substantive_law + professional_skills + practise_managment_skill + ethics_professional_responsibi);
        setProgram_date_time_line_2(metaData.Program_Date_Time_Line_2__c !== undefined && metaData.Program_Date_Time_Line_2__c !== null ? metaData.Program_Date_Time_Line_2__c : "");
        setProgram_date_time_line_1(metaData.Program_Date_Time_Line_1__c !== undefined && metaData.Program_Date_Time_Line_1__c !== null ? metaData.Program_Date_Time_Line_1__c : "");


        setVenue(metaData.Venue__c != undefined ? metaData.Venue__c : "");
        setDeliveryMode(metaData.delivery_mode != undefined ? metaData.delivery_mode : []);

        setLongPromotionMessage(metaData.Long_Promotion_Message__c != undefined ? metaData.Long_Promotion_Message__c : '');
        setShortPromotionMessage(metaData.Short_Promotion_Message__c != undefined ? metaData.Short_Promotion_Message__c : '');
        setProgram_Structure__c(isNotEmpty(metaData.Program_Structure__c) ? metaData.Program_Structure__c : undefined);


        set_reached_capacity(metaData.Reached_Capacity__c != undefined ? metaData.Reached_Capacity__c : false);
        setEarly_Bird_Price__c(isNotEmpty(metaData.Compare_Price) ? metaData.Compare_Price : undefined);


        setsDate(metaData.start_date_time !== undefined && metaData.start_date_time !== null ? metaData.start_date_time : null);
        setRecordType(metaData.RecordType != undefined ? metaData.RecordType : "");
        setpresentor(metaData.presentor != undefined ? metaData.presentor : []);
        set_Price_Message__c( (metaData.Price_Message__c !== undefined && metaData.Price_Message__c !== null) ? metaData.Price_Message__c : '' );

        Program_structure_images.filter(function (item, value) {
            var keyname = Object.keys(item);
            var tag_array = product.tags;
            if (tag_array.includes(keyname.toString())) {
                setProgram_structure_image(Object.values(item));
            }
        })


    }, [metaData])

    useEffect(() => {
        if (Price_Message__c && Price_Message__c.toLowerCase().includes("early")) {        
            set_show_early_bird(true);
        }
    },[Price_Message__c]);

    useEffect(() => {
        if (Price_Message__c && Price_Message__c.toLowerCase().includes("early")) {        
            set_show_early_bird(true);
        }
    },[Price_Message__c]);

    let author_index = 0;
    let top_author_index = 0;
    const randm = () => {
        return (Math.random() + 1).toString(36).substring(7);
    }



    useEffect(() => {
        if (sDate !== undefined && sDate !== null && sDate !== "") {
            setTEN_MIntLeft(is_ten_minite_less(sDate));
            setisProgramOver(program_date_is_gone_or_not(sDate));
            // console.log('program_date_is_gone_or_not -> '+sDate+' -> '+program_date_is_gone_or_not(sDate));
        }
    }, [sDate])

    useEffect(() => {
        setTotalCpdPoints(parseFloat(substantive_law) + parseFloat(professional_skills) + parseFloat(practise_managment_skill) + parseFloat(ethics_professional_responsibi));
    }, [substantive_law, professional_skills, practise_managment_skill, ethics_professional_responsibi])



    useEffect(() => {
        if (DeliveryMode.length) {
            const dfvalue = DeliveryMode[0];
            UpdateRadio(dfvalue == "" ? '' : dfvalue, 0);
        }
    }, [DeliveryMode])


    const price = product.priceRange.minVariantPrice.amount;
    const price_float = parseFloat(price);
    const dateFormat_sDate = new Date(sDate);
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const dayAbbr = sDate ? days[dateFormat_sDate.getDay()] : '';
    // Strip full day name already in the Salesforce field, replace with abbreviation
    const dayAbbrMap = { sunday: 'Sun', monday: 'Mon', tuesday: 'Tue', wednesday: 'Wed', thursday: 'Thu', friday: 'Fri', saturday: 'Sat' };
    const dateDisplay = program_date_time_line_1
      ? (dayAbbr
          ? dayAbbr + ' ' + program_date_time_line_1
              // strip leading full day name (replaced by dayAbbr above)
              .replace(/^(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday),?\s*/i, '')
              // replace any remaining full day names in the string (e.g. second date in a range)
              .replace(/\b(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday),?\s*/gi, (_, day) => dayAbbrMap[day.toLowerCase()] + ' ')
          : program_date_time_line_1)
      : '';
    const numberWithCommas = (x) => {
        return  parseFloat(x).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    }
    // Converts "6:00 PM to 7:00 PM" or "09:00 AM - 5:00 PM" → "6-7pm AEST"
    const formatTimeRange = (timeStr) => {
        if (!timeStr) return timeStr;
        const match = timeStr.match(/^(\d+):(\d+)\s*(AM|PM)\s+(?:to|-)\s+(\d+):(\d+)\s*(AM|PM)$/i);
        if (!match) return timeStr;
        const [, h1, m1, period1, h2, m2, period2] = match;
        const p1 = period1.toLowerCase();
        const p2 = period2.toLowerCase();
        // 12-hour display: midnight/noon are "12", never "0" (e.g. 0am → 12am).
        const hr12 = (h) => { const n = parseInt(h, 10) % 12; return n === 0 ? 12 : n; };
        const start = m1 === '00' ? String(hr12(h1)) : `${hr12(h1)}:${m1}`;
        const end   = m2 === '00' ? String(hr12(h2)) : `${hr12(h2)}:${m2}`;
        const range = p1 === p2 ? `${start}-${end}${p2}` : `${start}${p1}-${end}${p2}`;
        return `${range} AEST`;
    };

    return (

        <>
            <div className='product_grid_block'>
                <div className='product_grid_block_top'>
                    <div className='product_grid_block_title'>
                    <Link to={`/product/${product.handle+GAurl}`}> <h2 className='h3'>{sanitizeText(product.title)}</h2></Link>
                    </div>
                    <div className='product_grid_block_icons'>
                        {DeliveryMode.length ?
                            <>
                                {DeliveryMode.map((value,index) => {
                                    return <div key={index}> {value === "Live Stream" 
                                    ? <img src={laptop} alt={value} className={index == DefaultRadio ? 'selected': ''} onClick={() => UpdateRadio(value, index)} /> 
                                    : <img src={user} alt={value} className={index == DefaultRadio ? 'selected': ''} onClick={() => UpdateRadio(value, index)} />}</div>
                                })}

                            </> : null}
                    </div>
                </div>{/*product_grid_block_top */}
                <div className='product_grid_block_tags'>
                    <div className='product_grid_badges'>
                        {practise_managment_skill > 0 ? <img src={pm} alt="Practice Management & Business Skills" title="Practice Management & Business Skills" /> : null}
                        {professional_skills > 0 ? <img src={ps} alt="Professional Skills" title="Professional Skills" /> : null}
                        {substantive_law > 0 ? <img src={sl} alt="Substantive Law" title="Substantive Law" /> : null}
                        {ethics_professional_responsibi > 0 ? <img src={ep} alt="Ethics & Professional Responsibility" title="Ethics & Professional Responsibility" /> : null}
                    </div>
                    {reached_capacity
                        ? <span className='product_card_tag product_card_tag_booked'>Booked out</span>
                        : shortPromotionMessage ? <span className='product_card_tag'>{shortPromotionMessage}</span> : null}
                </div>
                <div className='product_grid_block_titmings'>
                    {
                        program_date_time_line_1 !== '' && program_date_time_line_1 !== undefined ?
                            (
                                <div className='inside_block'>
                                    <div className='icon'><img src={calendar} alt='calendar' /></div>
                                    <div className='content'>{dateDisplay}</div>
                                </div>
                            )
                            : ''
                    }
                    {
                        program_date_time_line_2 !== '' && program_date_time_line_2 !== undefined ?
                            (
                                <div className='inside_block'>
                                    <div className='icon'><img src={watch} alt='watch' /></div>
                                    <div className='content'>{formatTimeRange(program_date_time_line_2)}{venue && venue !== '' ? ' · ' + (venue === 'Live Stream Only' ? 'Online' : venue) : ''}</div>
                                </div>
                            )
                            : ''
                    }
                    {
                        /* Pre-recorded products (webcasts / online intensives) have no date —
                           show the program structure in its place, styled like the date text. */
                        (program_date_time_line_1 === '' || program_date_time_line_1 === undefined) && isNotEmpty(Program_Structure__c) ?
                            <div className='inside_block product_grid_structure'>
                                <div className='content'>{Program_Structure__c}</div>
                            </div>
                            : ''
                    }

                </div>
                <div className='product_grid_block_price'>
                    <div className='product_grid_bottom_row'>
                        {totalCpdPoints > 0 ? (
                            <div className='product_grid_cpd'>
                                <span className='cpd_num'>+{totalCpdPoints}</span>
                                <span className='cpd_lbl'>CPD Points</span>
                            </div>
                        ) : null}
                        {Early_Bird_Price__c !== undefined ? (
                            /* Early-bird price takes priority — shown even when booked out */
                            <div className='product_grid_price_box'>
                                {
                                    show_early_bird === true ? (<span className='early_bird_label'>EARLY BIRD PRICE</span>) : ''
                                }
                                
                                <span className='early_bird_struck'>${numberWithCommas(Early_Bird_Price__c)}</span>
                                <h3>${numberWithCommas(price_float)}</h3>
                            </div>
                        ) : reached_capacity ? (
                            <div className='product_grid_booked_price'>
                                <span className='booked_out_label'>Booked out</span>
                                <span className='price_struck'>${numberWithCommas(price_float)}</span>
                            </div>
                        ) : (
                            <div className='product_grid_price_box'>
                                <h3>${numberWithCommas(price_float)}</h3>
                            </div>
                        )}
                    </div>
                </div>
                <div className='product_grid_block_btns'>
                    {!TEN_MIntLeft ?
                        isProgramOver ? <div className="label_tag">Bookings Closed</div> :
                            reached_capacity
                                ? <div className="label_tag">Booked out</div>
                                : <>

                                    <a href='#' className='btn btn-secondary' onClick={(e) => AddtoCart(product.variants.edges[0].node.id, 1, product.variants.edges[0].node.sku, DefaultRadioValue, RecordType, product.tags, Program_structure_image, product.handle, sDate, Program_Structure__c)}>Add to cart</a>
                                </>
                        : <div className="label_tag">Bookings Closed</div>
                    }

                    <Link className="btn-link" to={`/product/${product.handle+GAurl}`}>Learn more</Link>
                    <span className={`card_bookmark_link${getAllWishlist && getAllWishlist.includes(product.handle) ? ' card_bookmark_link_add' : ''}`} onClick={() => AddtoWishlist && AddtoWishlist(product.handle, sDate)}>
                      {getAllWishlist && getAllWishlist.includes(product.handle) ? (bookmarkAddedLabel || 'Added to bookmarks') : 'Add to bookmarks'} <LikeIcon className="card_bookmark_icon" />
                    </span>
                </div>
            </div>

        </>
    )
}

export default ProductGridNew2;